import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  CustomBannerWrapper: styled(Flex, {
    background: '$backgroundSecondary',
    padding: '$2',
    gap: '$4',
    flexDirection: 'column',

    '@tablet': {
      padding: '$4 $7',
      flexDirection: 'row',
      gap: '$2',
    },
  }),

  CustomBannerTextWrapper: styled(Flex, {
    gap: '$2',
    '@tablet': {
      gap: '$1',
    },
  }),
};

export default styles;
